export default __webpack_public_path__ + "static/media/VRT-BNB.6be065bb.svg";